import React from "react";

// Runs the callback last set on the returned ref once, when the component
// unmounts: also when the broker leaves by a navigation nothing asks about.
// The ref may be set during render, so also below an early return that no
// hook may follow.
export const useOnUnmount = () => {
  const callbackRef = React.useRef<() => void>();

  // Lifecycle
  React.useEffect(() => {
    const latestCallbackRef = callbackRef;
    return () => latestCallbackRef.current?.();
  }, []);

  return callbackRef;
};
